module.exports = __webpack_public_path__ + "img/yg-logo.6e15b537.svg";